<template>
  <tr
    :id="firstRow ? 'firstRow' : null"
    :class="{ 'has-text-danger': deleted }">

    <td v-if="editing" class="data-column">
      <toggle-single
        :checked="removable"
        @toggle="$emit('toggleRemove')">
      </toggle-single>
    </td>

    <td
      class="content"
      v-for="(value, idx) in row"
      v-html="value ? parseValue(value) : ''"
      :key="idx"
      :nowrap="disableWrap(idx)">
    </td>

    <td
      v-if="editing"
      class="buttons-holder">

      <options-buttons
        v-if="deleted"
        :custom="[{ title: 'Regel herstellen', icon: 'fas fa-trash-restore', style: 'has-text-warning', click: { fnc: restore } }]"
        :editing="false"
        :deleting="false"
        :pullRight="true">
      </options-buttons>

      <options-buttons
        v-else
        v-show="!withTrashed"
        :pullRight="true"
        :custom="[{ title: 'Regel dupliceren', icon: 'far fa-clone', style: 'has-text-primary', click: { fnc: duplicate } }]"
        @edit="$emit('edit')"
        @delete="$emit('delete')">
      </options-buttons>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import { strMixin } from '@/mixins/str'
import OptionsButtons from '@/components/modules/OptionsButtons'
import ToggleSingle from '@/components/modules/mass-remove/ToggleSingle'

export default {
  props: {
    firstRow: {
      type: Boolean,
      default: false
    },
    row: {
      type: Array,
      default: null
    },
    editing: {
      type: Boolean,
      default: false
    },
    datasetId: {
      type: Number,
      default: null
    },
    removable: {
      type: Boolean,
      default: false
    },
    deleted: {
      type: String,
      default: null
    }
  },
  components: {
    ToggleSingle,
    OptionsButtons
  },
  mixins: [
    strMixin
  ],
  mounted () {
    if (this.firstRow) {
      this.$nextTick(() => {
        this.$emit('tableReady')
      })
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$emit('tableReady')
    })
  },
  computed: {
    ...mapGetters({
      report: 'reports/report',
      withTrashed: 'datasets/withTrashed'
    })
  },
  methods: {
    toggle (datasetId) {
      this.$store.dispatch('reports/toggle', datasetId)
      this.highlight = !this.highlight
    },
    parseValue (value) {
      return (this.isLink(value)) ? `<a href="${value}" target="_blank">${value}</a>` : `${value}`
    },
    isLink (value) {
      return /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/.test(value)
    },
    duplicate () {
      this.$emit('duplicate')
    },
    restore () {
      this.$emit('restore')
    },
    disableWrap (idx) {
      if (!this.withTrashed) {
        return false
      }

      if (idx >= this.row.length - 2) {
        return true
      }

      return false
    }
  }
}
</script>

<style scoped>
.buttons-holder {
  width: 150px;
}

tr:first-child td {
  border-top: 0;
}
</style>
